export const BF_GIFTS_SKUS = [
  'A03/DM25/1/10/PO',
  // 'LOS/ZESTAW/802/BF24/PO',
  // 'LOS/ZESTAW/803/BF24/PO',
]

export const validateGiftItems = (gifts: any, subTotalValue: number): any => {
  const toDelete: any = []
  const toReduceQt: any = []
  const [giftThreshold1, giftThreshold2, giftThreshold3]: any = BF_GIFTS_SKUS
  const findGift = (giftToFind: any) => {
    return (
        gifts.find((gift: any) => {
          return gift.product.sku === giftToFind
        }) !== undefined && gifts.find((gift: any) => gift.product.sku === giftToFind)
    )
  }
  // if (subTotalValue >= 549.0 && subTotalValue < 99999999) {
  //   if (findGift(giftThreshold1)) toDelete.push(findGift(giftThreshold1))
  //   if (findGift(giftThreshold2)) toDelete.push(findGift(giftThreshold2))
  //   if (findGift(giftThreshold3).quantity > 1) toReduceQt.push(findGift(giftThreshold3))
  //   return { toDelete, toReduceQt }
  // }
  // if (subTotalValue >= 449.0 && subTotalValue < 548.99) {
  //   if (findGift(giftThreshold1)) toDelete.push(findGift(giftThreshold1))
  //   if (findGift(giftThreshold2)?.quantity > 1) toReduceQt.push(findGift(giftThreshold2))
  //   if (findGift(giftThreshold3)) toDelete.push(findGift(giftThreshold3))
  //   return { toDelete, toReduceQt }
  // }
  if (subTotalValue >= 479.0 && subTotalValue < 99999999) {
    if (findGift(giftThreshold1)?.quantity > 1) toReduceQt.push(findGift(giftThreshold1))
    // if (findGift(giftThreshold2)) toDelete.push(findGift(giftThreshold2))
    // if (findGift(giftThreshold3)) toDelete.push(findGift(giftThreshold3))
    return { toDelete, toReduceQt }
  }
  if (findGift(giftThreshold1)) toDelete.push(findGift(giftThreshold1))
  // if (findGift(giftThreshold2)) toDelete.push(findGift(giftThreshold2))
  // if (findGift(giftThreshold3)) toDelete.push(findGift(giftThreshold3))
  return { toDelete, toReduceQt: [] }
}
